import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';
import { useState } from 'react';
import APIs from 'src/api';
import Filters from 'src/common/filterTable/components/Filters/Filters';
import FilterContainer from 'src/common/filterTable/layout/FilterContainer';
import FilterGrid from 'src/common/filterTable/layout/FilterGrid';
import FilterTableLayoutContainer from 'src/common/filterTable/layout/FilterTableLayoutContainer';
import TableContainer from 'src/common/filterTable/layout/TableContainer';
import PageConfigProvider, {
  usePageConfigProviderContext,
} from 'src/common/page/PageConfigProvider';
import { DivideLine, TableTab } from 'src/components/Layout';
import { Box } from 'src/components/MuiGenerals';
import { customSx } from 'src/utils/styling';
import BatchAllocateCreditDialog from './components/BatchAllocateCreditDialog';
import BatchAllocateCreditDialogToggle from './components/BatchAllocateCreditDialogToggle';
import useRenderFilters from './helper/useRenderFilters';
import useTableColumns from './helper/useTableColumns';
import useTableRows from './helper/useTableRows';
import { GetListRes } from './types/GetListRes';

const exportPermissionKey = AgentPortalFeatureCode.ClientManagement.CreditAllocation.Export;

const ViewFilterTable = () => {
  const { translatePrefix, list, onFilterSearch } = usePageConfigProviderContext<
    unknown,
    GetListRes
  >();

  const [isBatchAllocateCreditDialogOpen, setIsBatchAllocateCreditDialogOpen] = useState(false);

  const { filterFields } = useRenderFilters();
  const { columns, renderApproveRejectDialog, renderApprovalProgressDialog } = useTableColumns();
  const { rows, mapResultToTupleArray } = useTableRows({ apiList: list });

  return (
    <>
      {renderApproveRejectDialog()}
      {renderApprovalProgressDialog()}
      <BatchAllocateCreditDialog
        refetchTable={onFilterSearch}
        originalTranslatePrefix={translatePrefix}
        isOpen={isBatchAllocateCreditDialogOpen}
        setIsOpen={setIsBatchAllocateCreditDialogOpen}
      />
      <FilterTableLayoutContainer>
        <FilterContainer>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <BatchAllocateCreditDialogToggle setIsOpen={setIsBatchAllocateCreditDialogOpen} />
          </Box>
          <FilterGrid>
            <Filters filterFields={filterFields} />
          </FilterGrid>
          <PageConfigProvider.SearchAndResetBox />
        </FilterContainer>
        <DivideLine />
        <TableContainer>
          <Box sx={customSx.tableExportBar}>
            <PageConfigProvider.ExportButton
              fileName="Client Credit Allocation"
              permissionKey={exportPermissionKey}
              mapResultToTupleArray={mapResultToTupleArray}
              exportTableApiFunc={APIs.clientManagement.creditAllocation.getExport}
            />
          </Box>
          <TableTab>
            <PageConfigProvider.DataGrid columns={columns} rows={rows} />
          </TableTab>
        </TableContainer>
      </FilterTableLayoutContainer>
    </>
  );
};

export default ViewFilterTable;
